import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import * as api from "@/api/system_settings";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toastError } from "@/lib/api-errors";

export function ScanMethodCard({ current }: { current: "tsd" | "camera" | "both" }): React.ReactElement {
  const qc = useQueryClient();
  const [method, setMethod] = useState(current);
  useEffect(() => setMethod(current), [current]);
  const saveMut = useMutation({
    mutationFn: (v: "tsd" | "camera" | "both") => api.updateSystemSettings({ scan_method: v }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["system-settings"] });
      toast.success("Сохранено");
    },
    onError: toastError("Ошибка сохранения"),
  });
  const opts: { v: "tsd" | "camera" | "both"; label: string; hint: string }[] = [
    { v: "tsd", label: "ТСД (сканер)", hint: "аппаратный сканер, кнопки камеры нет" },
    { v: "camera", label: "Камера устройства", hint: "сканирование камерой" },
    { v: "both", label: "Оба", hint: "сканер + камера" },
  ];
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Способ сканирования</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-xs text-muted-foreground">
          Общая настройка всех скан-экранов: проверка заказов и перемещений, приёмка
          возвратов, ФБС.
        </p>
        {opts.map((o) => (
          <label key={o.v} className="flex items-start gap-2 text-sm">
            <input
              type="radio"
              name="scan_method"
              checked={method === o.v}
              onChange={() => {
                setMethod(o.v);
                saveMut.mutate(o.v);
              }}
              disabled={saveMut.isPending}
              className="mt-0.5 size-4"
            />
            <span>
              <span className="font-medium">{o.label}</span>
              <span className="ml-2 text-xs text-muted-foreground">{o.hint}</span>
            </span>
          </label>
        ))}
      </CardContent>
    </Card>
  );
}
